import { Checkbox, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Controller } from "react-hook-form";
import CustomProductSelect from "../../../unit/forms/CustomProductSelect";
import CustomProductTextField from "../../../unit/forms/CustomProductTextField";
import MuiCheckboxGroup from "../../../unit/forms/MuiCheckboxGroup";
const ShowUploadDocsField = ({ ...props }) => {
  const control = props.control;
  const item = props.item;
  const code = item?.sCode;
  const title = item?.sTitle;
  const showTextreader = item?.showTextreader;
  // const coreCodeData = item?.coreCodeData;

  const setting = item?.sSetting;
  const docMinCount = setting?.docMinCount;
  const sOption = setting?.sOption;
  const textreader = setting?.textreader;
  const sAdditionalConditions = setting?.sAdditionalConditions;
  const sAcceptableDocs = setting?.sAcceptableDocs;
  const sAcceptableDocsList = setting?.sAcceptableDocsList;
  const sAcceptableDocsMultiList = setting?.sAcceptableDocsMultiList;
  const showLimitLabel = item?.showLimitLabel;

  const acceptDocsOptions: any[] | undefined = [];
  Object.entries(sAcceptableDocsList).forEach(([key, value]) => {
    acceptDocsOptions.push({
      id: value?.doc_code,
      name: value?.doc_title,
    });
  });

  function getCheckboxGroupValue(list: any) {
    if (!list) return [];
    const optionlist: any[] | undefined = [];
    Object.entries(list).forEach(([key, value]) => {
      optionlist.push({
        id: value?.doc_code,
        name: value?.doc_title,
      });
    });

    console.log("optionlist===>", optionlist);
    return optionlist;
  }

  function getMultiCheckedValue(
    businessKey: string,
    list: Record<string, unknown>
  ): Array<{ value: string }> {
    if (!businessKey || typeof businessKey !== "string") {
      console.warn("Invalid businessKey provided");
      return [];
    }

    if (!list || typeof list !== "object") {
      console.warn("Invalid list provided");
      return [];
    }

    const result: Array<{}> = [];

    for (const [key, val] of Object.entries(list)) {
      try {
        const stringValue = val?.toString() || "";
        const processedValue = stringValue.replace(`${businessKey}/`, "");

        result.push(processedValue);
      } catch (error) {
        // console.error(`Error processing value for key ${key}:`, error);
        continue;
      }
    }

    // console.log("Processed multi-checked values:", businessKey, result);
    return result;
  }

  let minOptions = [
    { value: 0, label: "N/A" },
    { value: 9, label: "OPTION" },
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
  ];
  if (showLimitLabel == "Minimum Months") {
    minOptions = [
      { value: 0, label: "N/A" },
      { value: 1, label: "1" },
      { value: 2, label: "2" },
      { value: 3, label: "3" },
      { value: 6, label: "6" },
      { value: 9, label: "9" },
      { value: 12, label: "12" },
    ];
  }
  if (showLimitLabel == "Minimum Years") {
    minOptions = [
      { value: 0, label: "N/A" },
      { value: 1, label: "1" },
      { value: 2, label: "2" },
      { value: 3, label: "3" },
      { value: 4, label: "4" },
      { value: 5, label: "5" },
      { value: 6, label: "6" },
    ];
  }

  return (
    <>
      {code == "statements_checking" && (
        <>
          <Grid container spacing={2} sx={{ paddingBottom: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {/* checkbox ,name = financial_account, value = FINANCIAL ACCOUNT */}
              <Controller
                name="financial_account"
                control={control}
                defaultValue={
                  props?.statements_checkbox_checked == 1
                    ? "FINANCIAL ACCOUNT"
                    : ""
                }
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    checked={field.value === "FINANCIAL ACCOUNT"}
                    onChange={(e) => {
                      field.onChange(
                        e.target.checked ? "FINANCIAL ACCOUNT" : ""
                      );
                    }}
                    color="primary"
                  />
                )}
              />
              {/* {props?.statements_checkbox_checked}-- */}
              The Following Will Not Be Required If Applicant Has Connected
              Online Financial Account
            </Typography>
          </Grid>
        </>
      )}
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: "#f5f5f5",
        }}
      >
        <Grid item xs={8}>
          <Typography variant="h6" gutterBottom sx={{ marginTop: "5px" }}>
            {/* <b style={{ color: "red" }}>{code} </b> */}
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            "& .MuiTextField-root": {
              marginTop: "0px",
            },
          }}
        >
          {showTextreader == 1 && (
            <Controller
              name={`proof_${code}_textreader`}
              defaultValue={textreader}
              control={control}
              render={({ field }) => (
                <CustomProductSelect
                  {...field}
                  label="Automatic Text Reader"
                  variant="outlined"
                  optionlist={[
                    { value: "On", label: "On" },
                    { value: "Off", label: "Off" },
                  ]}
                />
              )}
            />
          )}
          {code == "affiliation" && (
            <Controller
              // name={`affiliationoption`}
              name={`proof_${code}_option`}
              control={control}
              defaultValue={sOption}
              render={({ field }) => (
                <CustomProductTextField
                  {...field}
                  variant="outlined"
                  label="Affiliation Option"
                  fullWidth
                  placeholder="Enter Affiliation Option"
                />
              )}
            />
          )}
          {code == "hardship" && (
            <Controller
              // name={`hardshipoption`}
              name={`proof_${code}_option`}
              control={control}
              defaultValue={sOption}
              render={({ field }) => (
                <CustomProductTextField
                  {...field}
                  variant="outlined"
                  label="Hardship Option"
                  fullWidth
                  placeholder="Enter Hardship Option"
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={2} sx={{ paddingRight: 1, paddingBottom: 1 }}>
          <Controller
            name={showLimitLabel ? `proof_${code}_option` : `proof_${code}_min`}
            defaultValue={showLimitLabel ? sOption : docMinCount}
            control={control}
            render={({ field }) => (
              <CustomProductSelect
                {...field}
                variant="outlined"
                label={showLimitLabel ? showLimitLabel : "Minimum Documents"}
                optionlist={minOptions}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ padding: 2, paddingBottom: 3, paddingLeft: 5 }}>
            {/* <Typography>dddd</Typography>
            {acceptDocsOptions && <div>{acceptDocsOptions}</div>}
             */}
            {(!sAcceptableDocsMultiList ||
              sAcceptableDocsMultiList.length == 0) && (
              <>
                <Controller
                  name={`proof_${code}_accepttype`}
                  control={control}
                  defaultValue={sAcceptableDocs}
                  render={({ field }) => (
                    <MuiCheckboxGroup
                      {...field}
                      choices={acceptDocsOptions}
                      // defaultSelected={sAcceptableDocs}
                      // defaultSelected={[5, 7, 18]} // 在这里设置默认值，使用数字而非字符串
                    />
                  )}
                />
              </>
            )}

            {sAcceptableDocsMultiList &&
              sAcceptableDocsMultiList.map((acceptItem: any) => {
                //     "label" => "501(c)(19) veterans organization",
                // "allAcceptableDocs" => array(
                // 	"articles_incorporateion",
                // )
                return (
                  <>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ marginTop: "5px" }}
                    >
                      {/* <b style={{ color: "red" }}>{acceptItem.code} </b> */}
                      {acceptItem.label}
                    </Typography>
                    <div style={{ marginLeft: "50px" }}>
                      {acceptItem.allAcceptableDocs && (
                        <>
                          {/* {`proof_${code}_${acceptItem.code}_accepttype`}--- */}
                          <Controller
                            name={`proof_${code}_${acceptItem.code}_accepttype`}
                            control={control}
                            // defaultValue={sAcceptableDocs}
                            defaultValue={getMultiCheckedValue(
                              acceptItem.code,
                              sAcceptableDocs
                            )}
                            // defaultValue={["certificate_limited_partnership"]}
                            render={({ field }) => (
                              <MuiCheckboxGroup
                                {...field}
                                choices={getCheckboxGroupValue(
                                  acceptItem.sAcceptableDocsList
                                )}
                                // defaultSelected={[5, 7, 18]} // 在这里设置默认值，使用数字而非字符串
                              />
                            )}
                          />
                        </>
                      )}
                    </div>
                  </>
                );
              })}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ShowUploadDocsField;
// @if (isset($corecodeSetting['id']) && in_array($loantypeInfo -> sSubType, $corecodeSetting['id']))
//     <tr class="ttitle">
//         <td style="width:50%;" class="">
//             {{$coreCodeData['id']}}
//         </td>
//         <td style="width:50%;text-align:right;">
//             <div style="float:left;width:300px;">
//                 Automatic Text Reader
//                 <span class="select-wrap light">
//                   <b class="icon-arrow-down"></b>
//                   <select class="providedby normaltext sbox" id = "ID_textreader" name="ID_textreader" style="width:60px;" >
//                           <option value="">Select</option>
//                           <option @if(isset($proof_documents['ID']['textreader']) && $proof_documents['ID']['textreader'] == 'On') selected @endif value="On">On</option>
//                           <option @if(isset($proof_documents['ID']['textreader']) && $proof_documents['ID']['textreader'] == 'Off') selected @endif value="Off">Off</option>
//                   </select>
//                 </span>
//                 </div>
//             Minimum Documents
//             <span class="select-wrap light">
//               <b class="icon-arrow-down"></b>
//                                       <select class="providedby normaltext sbox" id = "proof_govemmentID_min" name="proof_govemmentID_min" >
//                                                 <option value="0">N/A</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 9) selected @endif value="9">Optional</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 1) selected @endif value="1">1</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 2) selected @endif value="2">2</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 3) selected @endif value="3">3</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 4) selected @endif value="4">4</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 5) selected @endif value="5">5</option>
//                                                 <option @if($proof_documents['ID']['docMinCount'] == 6) selected @endif value="6">6</option>
//               </select>
//             </span>
//         </td>
//     </tr>

//     <tr>
//         <td colspan=2 style="text-align:left;">
//             <input type="checkbox" @if(in_array("passport", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_passport" name="proof_govemmentID_accepttype[]" value="passport" />{{$coreCodeData['passport']}} <br>
//             <input type="checkbox" @if(in_array("non-usa-passport", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_passport" name="proof_govemmentID_accepttype[]" value="non-usa-passport" />{{$coreCodeData['non-usa-passport']}} <br>
//             <input type="checkbox" @if(in_array("idcard", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_municipal" name="proof_govemmentID_accepttype[]" value="idcard" />{{$coreCodeData['idcard']}}  <br>
//             <input type="checkbox" @if(in_array("driver", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="driver" />{{$coreCodeData['driver']}} <br>
//             <input type="checkbox" @if(in_array("greencard", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="greencard" />{{$coreCodeData['greencard']}} <br>
//             <input type="checkbox" @if(in_array("employmentauth", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="employmentauth" />{{$coreCodeData['employmentauth']}} <br>
//             <input type="checkbox" @if(in_array("traveldocument", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="traveldocument" />{{$coreCodeData['traveldocument']}} <br>
//             <input type="checkbox" @if(in_array("studentid", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="studentid" />{{$coreCodeData['studentid']}} <br>
//             <input type="checkbox" @if(in_array("special_immigration_visa", $proof_documents['ID']['sAcceptableDocs'])) checked @endif style="margin-left:30px;" id="proof_govemmentID_driver_license" name="proof_govemmentID_accepttype[]" value="special_immigration_visa" />{{$coreCodeData['special_immigration_visa']}}
//         </td>
//     </tr>
//     @endif
